import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { MoreHorizontal } from 'lucide-react';

export const McpHistoryItemMenuToggle = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(function McpHistoryItemMenuToggle({ onClick, className, ...props }, ref) {
  return (
    <button
      type="button"
      ref={ref}
      {...props}
      className={`mcp-history-item-menu-btn${className ? ` ${className}` : ''}`}
      onClick={event => {
        event.preventDefault();
        event.stopPropagation();
        onClick?.(event);
      }}
      aria-label="گزینه‌های گفتگو"
      title="گزینه‌ها"
    >
      <MoreHorizontal size={15} strokeWidth={2} />
    </button>
  );
});
